/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnumPropertyConfig } from "./EnumPropertyConfig";
import { BaseProperty } from "./BaseProperty";
export const EnumListProperty = core.serialization
    .object({
    config: EnumPropertyConfig,
})
    .extend(BaseProperty);
